import type { DocSection } from '../types'

export const troubleshootingSection: DocSection = {
  id: 'depannage',
  title: 'Dépannage',
  icon: 'help-circle',
  accent: '#64748B',
  summary: "Les soucis courants et comment les régler depuis l'application.",
  minRole: 'agent',
  articles: [
    {
      id: 'softphone',
      title: 'Le téléphone ne se connecte pas',
      summary: 'Pas de tonalité, « non connecté », appels impossibles.',
      icon: 'phone-off',
      blocks: [
        { type: 'faq', items: [
          { q: 'Le panneau indique « non connecté »', a: "Vérifiez votre connexion Internet puis **rechargez** l'application. Si le problème persiste, demandez à un responsable de vérifier votre **poste** dans la page Utilisateurs." },
          { q: "Je n'entends rien / on ne m'entend pas", a: "Vérifiez le **casque** choisi dans votre ordinateur, le bouton **micro coupé** du téléphone, et l'autorisation **micro** de l'application. Un casque filaire évite la plupart des soucis audio." },
          { q: 'Le bouton Appeler est grisé', a: "Un appel est déjà en cours (terminez-le d'abord), ou vous n'êtes pas en statut **Disponible**." },
        ] },
      ],
    },
    {
      id: 'connexion',
      title: 'Je n\'arrive pas à me connecter',
      summary: 'Mot de passe, heures de travail, double connexion.',
      icon: 'user-x',
      blocks: [
        { type: 'faq', items: [
          { q: 'Mot de passe oublié', a: "Utilisez « Mot de passe oublié » sur l'écran de connexion pour recevoir un lien de réinitialisation." },
          { q: 'Connexion refusée alors que mon mot de passe est bon', a: "Vous êtes peut-être **hors de vos heures de travail** autorisées. Voir [[utilisateurs/horaires|Heures de travail]] — contactez votre responsable." },
          { q: 'On me déconnecte tout seul', a: "Un compte ne peut être utilisé que sur **un seul appareil à la fois** : se connecter ailleurs ferme la session ici. Ne partagez pas votre compte." },
        ] },
      ],
    },
    {
      id: 'app',
      title: "L'application s'est figée après une mise à jour",
      summary: 'Écran blanc ou erreur après une mise à jour.',
      icon: 'refresh',
      blocks: [
        { type: 'p', text: "Après une mise à jour, l'application **se recharge normalement toute seule**. Si elle se fige (écran blanc) :" },
        { type: 'steps', items: [
          "**Rechargez** l'application (ou fermez puis rouvrez).",
          "Si cela persiste, **videz le cache** puis rouvrez.",
        ] },
      ],
    },
    {
      id: 'appels',
      title: 'Un problème pendant les appels',
      summary: 'Appels qui échouent, mauvais numéro affiché.',
      icon: 'phone-off',
      minRole: 'team_admin',
      blocks: [
        { type: 'faq', items: [
          { q: 'Les appels sortants échouent', a: "C'est généralement lié à l'**opérateur** : ligne saturée (trop d'appels en même temps) ou réglage à corriger. Vérifiez l'état de l'opérateur dans la page **Téléphonie** ; au besoin, contactez votre administrateur ou le support de l'opérateur." },
          { q: 'Le mauvais numéro s\'affiche chez la personne appelée', a: "Le numéro présenté suit un ordre de priorité (campagne, puis agent, équipe, réglage global). Vérifiez chaque niveau — voir [[telephonie/caller-id|Numéro présenté]]." },
          { q: 'Des répondeurs arrivent aux agents en mode progressif', a: "La reconnaissance des répondeurs est réglée côté technique. **Signalez-le à votre administrateur** pour qu'il ajuste la sensibilité — voir [[dialer/repondeurs|Et les répondeurs ?]]." },
        ] },
      ],
    },
  ],
}
